import * as React from 'react';
import { Row, Col, Input, Button, Icon, Checkbox, Popover } from 'antd';
import '../../css/OrganizationAddEdit.scss';
import strings from '../../eyeguide-localization/customer/string.customer.add';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import Util from '../common/utils';
import service from '../../service/apolloclient.service';

interface IContentOneProps {
    handleNextClick: any;
    customer: any;
}

/**
 * State definition
 */
interface IContentOneState {
    classesWithErr: string;
    classesWithoutErr: string;
    errorname:    boolean;
    errorCname:    boolean;
    errorCphone:    boolean;
    errorCemail:    boolean;
    name:           string;
    contactfname:    string;
    contactlname:    string;    
    contactphone:   string;
    contactemail:   any;
    address:        string;
    email:          string;
    website:        string;
    testtags:       string;
    enableprivacy:  boolean;
    enablebestbaseline: boolean;
    enablefailedtestreport: boolean;
    viewinapptest:  boolean;
    viewinappbaseline: boolean;
    current:        number;
    country:        string;
    region:         string;
    errorLname:     boolean;
    jobTitle:       string;
    city:           string;
    pincode:        string;
    showNameCheck:  boolean;
    nameCheckType:  string;
    nameCheckColor: string;
}

var search: any = undefined;

export default class ContentOne extends React.Component<IContentOneProps, IContentOneState> {

    constructor(props: IContentOneProps) {
        super(props); 
        this.state = {
            classesWithErr : 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorname: false,
            errorCname: false,
            errorCemail: false,
            errorCphone: false,
            name            : this.props.customer.name,
            contactfname    : this.props.customer.contactfirstname,
            contactlname    : this.props.customer.contactlastname,
            contactphone    : this.props.customer.contactphone,
            address         : this.props.customer.address,
            website         : this.props.customer.website,
            contactemail    : this.props.customer.contactemail,
            email           : this.props.customer.email,
            current         : 0,
            country         : this.props.customer.country !== undefined ? 
                                    this.props.customer.country : 'United States'  ,
            region          : this.props.customer.state,
            city            : this.props.customer.city,
            errorLname      : false,
            testtags        : this.props.customer.testtags,
            enableprivacy   : this.props.customer.enableprivacy,
            enablebestbaseline   : this.props.customer.enablebestbaseline,
            enablefailedtestreport : this.props.customer.enablefailedtestreport,
            viewinappbaseline : this.props.customer.viewinappbaseline,
            viewinapptest   : this.props.customer.viewinapptest,
            jobTitle        : this.props.customer.jobtitle,
            pincode         : this.props.customer.pincode,
            showNameCheck   : false,
            nameCheckType   : '',
            nameCheckColor  : ''
        };
    }

    render() {

        let content = (
            <span>If enabled will,<br/>
            - Encrypt the players personal information<br/>
            - Disable web login for users other than organization admin</span>
        );

        let contentBestBaseline = (
            <span>If enabled, will display the test against the best baseline in last 24 months</span>
        );

        let contentEnableFailedTestReport = (
            <span>If enabled, will display failed tests under the test report section</span>
        );

        return (
            <div className="content">
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">
                            <span>{strings.lsOrgName}
                                <span className="labelReq"> * </span>
                            :</span>
                        </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input 
                            value={this.state.name}
                            onChange={(val) => this.setState({name: val.target.value})}
                            className={this.state.errorname ? 
                                    this.state.classesWithErr : this.state.classesWithoutErr}
                            placeholder="e.g. High School USA" 
                            autoFocus={true}
                            onBlur={() => this.validateCustomerName()}
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={4} xl={3}>                   
                    {this.state.showNameCheck ? 
                        <div>
                        <Col xs={1} sm={1} md={2} lg={5} xl={5}>
                        <Icon 
                            className="iconStyle"
                            style={{paddingTop: '5px' , 
                                    color: this.state.nameCheckColor , 
                                    fontSize: '19px'}}
                            type={this.state.nameCheckType}
                        /> </Col>
                        <Col xs={1} sm={1} md={2} lg={19} xl={19}>
                        {this.state.nameCheckColor === 'red' ? 
                            <span className="hyphenate"> {strings.lsCustomerExistsTxt} 
                            </span> : ''}
                        </Col>
                        </div>
                        : ''}
                    </Col>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">
                            <span>{strings.lsContactFirstNameTxt} 
                                <span className="labelReq"> * </span>     
                            :</span>
                        </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input 
                            value={this.state.contactfname}
                            onChange={(val) => this.setState({contactfname: val.target.value})}
                            className={this.state.errorCname ? 
                                            this.state.classesWithErr : this.state.classesWithoutErr}
                            placeholder="e.g. Johnny"
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">
                            <span>{strings.lsContactLastNameTxt} 
                                <span className="labelReq"> * </span>     
                            :</span>
                        </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input 
                            value={this.state.contactlname}
                            onChange={(val) => this.setState({contactlname: val.target.value})}
                            className={this.state.errorLname ? 
                                            this.state.classesWithErr : this.state.classesWithoutErr}
                            placeholder="e.g. Thomas"
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">
                            <span>{strings.lsContactJobTitle} 
                                {/* <span className="labelReq"> * </span>      */}
                            :</span>
                        </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input 
                            value={this.state.jobTitle}
                            onChange={(val) => this.setState({jobTitle: val.target.value})}
                            placeholder="e.g. Manager"
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                    <div className="label">
                            <span>{strings.lsContactPhoneTxt} 
                                <span className="labelReq"> * </span>     
                            :</span>
                    </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input 
                            value={this.state.contactphone}
                            onChange={(val) => this.setState({contactphone: val.target.value})}
                            className={this.state.errorCphone ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                            placeholder="e.g. 123-456-789" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                    <div className="label">
                            <span>{strings.lsContactEmailTxt} 
                                <span className="labelReq"> * </span>     
                            :</span>
                    </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input
                            value={this.state.contactemail}
                            onChange={(val) => this.setState({contactemail: val.target.value})}
                            className={this.state.errorCemail ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                            placeholder="e.g. johny.thomas@school.edu" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                    <div className="label">{strings.lsAddressTxt} :</div></Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input 
                            value={this.state.address}
                            onChange={(val) => this.setState({address: val.target.value})}
                            placeholder="e.g. 123 At, Philadelphia, PA" 
                        />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsCityTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.city}
                                onChange={(val) => this.setState({city: val.target.value})}
                                placeholder="e.g. Franklin" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsStateTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            {/* <Input 
                                value={this.state.address}
                                onChange={(val) => this.setState({address: val.target.value})}
                                placeholder="eg 123 At, Philadelphia, PA" 
                            /> */}
                            <div className="selectdiv">
                                <RegionDropdown
                                    classes="contentCountry"
                                    defaultOptionLabel={strings.lsSelectRegion}
                                    country={this.state.country}
                                    value={this.state.region}
                                    onChange={(val) => this.selectRegion(val)} 
                                />
                            </div>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsCountryTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            {/* <Input 
                                value={this.state.address}
                                onChange={(val) => this.setState({address: val.target.value})}
                            placeholder="eg 123 At, Philadelphia, PA" 
                            /> */}
                            <div className="selectdiv">
                            <CountryDropdown
                                classes="contentCountry"
                                value={this.state.country}
                                onChange={(val) => this.selectCountry(val)} 
                            />
                            </div>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsZipPostalCodeTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.pincode}
                                onChange={(val) => this.setState({pincode: val.target.value})}
                                placeholder="e.g. 10080" 
                            />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={1} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsOrgEmailTxt} :</div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input 
                            value={this.state.email}
                            onChange={(val) => this.setState({email: val.target.value})}
                            placeholder="e.g. admin@school.edu" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={1} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame">
                    <div className="label">{strings.lsWebsiteTxt} :</div></Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input 
                            value={this.state.website}
                            onChange={(val) => this.setState({website: val.target.value})}
                            placeholder="e.g. www.schoolsite.edu" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={1} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame">
                    <div className="label">{strings.IsTestTags} :</div></Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Row className="tagsContainer" hidden={!this.state.testtags || this.state.testtags === ''}>
                            <Col>
                                {this.renderTags()}
                            </Col>
                        </Row>
                        <Row>
                            <Input.Search
                                ref={(e) => search = e}
                                enterButton={<Icon type="plus" />}
                                onSearch={(val) => this.handleAddTag(val)}
                                placeholder="e.g. Test" 
                            />
                        </Row>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={1} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame checkboxFrame">
                    <div className="label">
                        <Popover trigger="hover" content={content}>
                            <Icon className="infoIcon" type="info" />
                        </Popover> 
                        &nbsp; {strings.IsPrivacyEnabled} :
                    </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Checkbox 
                            checked={this.state.enableprivacy}
                            onChange={(e) => this.setState({enableprivacy: e.target.checked})}
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={1} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame checkboxFrame">
                    <div className="label">
                        <Popover trigger="hover" content={contentBestBaseline}>
                            <Icon className="infoIcon" type="info" />
                        </Popover> 
                        &nbsp; {strings.lsEnableBestBaseline} :
                    </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Checkbox 
                            checked={this.state.enablebestbaseline}
                            onChange={(e) => this.setState({enablebestbaseline: e.target.checked})}
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={1} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame checkboxFrame">
                    <div className="label">
                        <Popover trigger="hover" content={contentEnableFailedTestReport}>
                            <Icon className="infoIcon" type="info" />
                        </Popover> 
                        &nbsp; {strings.lsEnableFailedTestReport} :
                    </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Checkbox 
                            checked={this.state.enablefailedtestreport}
                            onChange={(e) => this.setState({enablefailedtestreport: e.target.checked})}
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                { this.state.enableprivacy && <Row className="row" type="flex">
                        <Col xs={1} sm={1} md={1} lg={3} xl={5} />
                        <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame checkboxFrame">
                        <div className="label">{strings.IsViewInAppTestTxt} :</div>
                        </Col>
                        <Col>
                            <Checkbox 
                                checked={this.state.viewinapptest}
                                onChange={(e) => this.setState({viewinapptest: e.target.checked})}
                            />
                        </Col>
                        <Col xs={8} sm={8} md={6} lg={6} xl={4} className="labelFrame checkboxFrame">
                            <div className="label">{strings.IsViewInAppBaseline} :</div>
                        </Col>
                        <Col >
                            <Checkbox 
                                checked={this.state.viewinappbaseline}
                                onChange={(e) => this.setState({viewinappbaseline: e.target.checked})}
                            />
                        </Col>
                        <Col />
                </Row>}                
                <Row>
                    <Col span={12} style={{padding: '10px'}}>
                        <div className="buttonRight"> 
                            <Button 
                                onClick={e => {
                                    let isValid: boolean = true;
                                    isValid = this.getOrgObj();
                                    // this.processOrg
                                    //     (this.getOrgObj(), 1, ''); // add
                                    if (isValid !== false) {
                                        this.props.handleNextClick(isValid, 1); 
                                    }
                                }}     
                                type="primary" 
                                style={{width: '100%'}}
                            > 
                            {strings.lsNextTxt} 
                            </Button> 
                        </div>
                    </Col>
                    <Col span={12} style={{padding: '10px'}}>
                        <div className="buttonLeft"> 
                            <Button 
                                    onClick={e => {
                                        history.back();
                                                }} 
                                    type="danger" 
                                    style={{width: '100%'}}
                            > 
                            {strings.lsCancelTxt} 
                            </Button> 
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    renderTags() {
        var list = this.state.testtags ? this.state.testtags.split(',') : [];
        return list.map((item, index) => {
            return item !== '' ? ( 
                <Row justify="end" className="testTag" key={item + index}> 
                    <Col className="text"><span>{item}</span></Col>
                    <Col className="iconCol">
                        <Icon 
                            className="tagIcon" 
                            type="delete" 
                            onClick={(e => this.handleDeleteTag(item))}
                        />
                    </Col> 
                </Row>
            ) : null;
        });
    }

    /**
     * coverts string into an array and removes the item.
     * @param item tag
     */
    handleDeleteTag(item: string) {
        var list = this.state.testtags.split(',');
        list.splice(list.indexOf(item), 1);
        this.setState({testtags: list.join(',')});
    }

    /**
     * appends the item to the coma seperated list
     * @param item tag
     */
    handleAddTag(item: string) {
        search.input.input.value = '';    
        return item.match(/^\s+$|^$/gi) ? null : this.setState({testtags: this.state.testtags ? 
            this.formatTags(this.state.testtags, true) + item + ',' : item + ','});
    }

    /**
     * Removes or appends the comma from the string as needed
     * @param testtags comma seperated string 
     * @param isStart if true checks the end of the string for a comma
     */
    formatTags(testtags: string, isStart: boolean) {
        var str = isStart ? 
            (testtags[testtags.length - 1] !== ',' ? 
            testtags + ',' : testtags) :
            (testtags[testtags.length - 1] === ',' ? 
            testtags.slice(0, testtags.length - 1) : testtags);
        return str;
    }

    /**
     * Returns organization object in json format
     * to be sent to server for processing
     */
    private getOrgObj(): any {
        if (this.validateInput() && this.state.nameCheckColor !== 'red') {
            var privacy =  this.state.enableprivacy !== null ? this.state.enableprivacy : false;
            var bestBaseline = this.state.enablebestbaseline !== null ? this.state.enablebestbaseline : false;
            var enableFailedTestReport = this.state.enablefailedtestreport !== null ? 
                                                        this.state.enablefailedtestreport : false;
            let inputOrg: any = {
                'name': this.state.name !== null ? this.state.name.trim() : '',
                'contactfirstname': this.state.contactfname !== null ? this.state.contactfname.trim() : '',
                'contactlastname': this.state.contactlname !== null ? this.state.contactlname.trim() : '',
                'contactphone': this.state.contactphone !== null ? this.state.contactphone.trim() : '',
                'jobtitle': this.state.jobTitle !== null && this.state.jobTitle !== undefined
                             ? this.state.jobTitle.trim() : '',
                'contactemail': this.state.contactemail !== null ? this.state.contactemail.trim() : '',
                'address': this.state.address !== null && this.state.address !== undefined
                                     ? this.state.address.trim() : '',
                'city': this.state.city !== null && this.state.city !== undefined
                ? this.state.city.trim() : '',
                'state': this.state.region !== null && this.state.region !== undefined
                ? this.state.region.trim() : '',
                'country': this.state.country !== null && this.state.country !== undefined
                ? this.state.country.trim() : '',
                'pincode': this.state.pincode !== null && this.state.pincode !== undefined
                ? this.state.pincode.trim() : '',
                'email': this.state.email !== null && this.state.email !== undefined 
                                     ? this.state.email.trim() : '',
                'website': this.state.website !== null && this.state.website !== undefined
                                     ? this.state.website.trim() : '',
                'testtags': this.state.testtags !== null && this.state.testtags !== undefined
                                     ? this.formatTags(this.state.testtags, false) : '',
                'enableprivacy': privacy,
                'enablebestbaseline': bestBaseline,
                'enablefailedtestreport': enableFailedTestReport,
                'viewinapptest': privacy ? (this.state.viewinapptest ? true : false) : false,
                'viewinappbaseline': privacy ? (this.state.viewinappbaseline  ? true : false) : false
                };  
            return inputOrg;
        } else {
            return false;
        }       
    }
    
    /**
     * Validate input values provided by the user before submitting to server 
     */
    private validateInput(): boolean {
        let isValid: boolean = true;
        let errorname: boolean = false;
        let errorCname: boolean = false;
        let errorLname: boolean = false;
        let errorCphone: boolean = false;
        let errorCemail: boolean = false;
        this.state.name !== null && (this.state.name === undefined || this.state.name.trim() === '') ? 
                    errorname = true : errorname = false;
        this.state.contactfname !== null && 
                (this.state.contactfname === undefined || this.state.contactfname.trim() === '') ? errorCname = true 
                    : errorCname = false;
        this.state.contactlname !== null && 
                (this.state.contactlname === undefined || this.state.contactlname.trim() === '') ? errorLname = true 
                    : errorLname = false;
        this.state.contactphone !== null && 
                    (this.state.contactphone === undefined || this.state.contactphone.trim() === '')
                    ? errorCphone = true 
                    : errorCphone = false;
        this.state.contactemail !== null &&  
                    (this.state.contactemail === undefined || this.state.contactemail.trim() === '') 
                    ? errorCemail = true 
                : errorCemail = false;
        errorCemail = errorCemail ? errorCemail : !Util.validateEmail(this.state.contactemail);
        if (errorname || errorCname || errorCphone || errorCemail || errorLname) { isValid = false; }
        this.setState({errorname, errorCname, errorCemail, errorCphone, errorLname});
        return isValid;
    }

    private selectCountry (val: string) {
        this.setState({ country: val });
    }

    private selectRegion(val: string) {
        this.setState({ region: val });
    }

    /**
     * Validates the username provided by user while creating user,
     * by calling the server
     */
    private async validateCustomerName() {
        console.log('validate', this.state.name !== null && this.state.name !== undefined 
                                ? this.state.name.trim() : '');
        let ser = new service();
        let response: any;
        if (this.state.name !== null && this.state.name !== undefined
                         && this.state.name.trim().length > 0 ) {
            response = await ser.verifyCustomerName(this.state.name.trim());
            console.log('response', response);
            if (response.status === 0) { // success
                this.setState({
                    showNameCheck: true,
                    nameCheckType: 'check-circle', // 'check-circle'
                    nameCheckColor: '#4ddb33b0' // '#4ddb33b0'
                });
            } else {
                this.setState({
                    showNameCheck: true,
                    nameCheckType: 'close-circle', // 'check-circle'
                    nameCheckColor: 'red' // '#4ddb33b0'
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/customer/ContentOne.tsx